import { Outlet } from "react-router";
import logo from "../assets/images/yellow-transparent.png";
import SideMenu from "../components/common/SideMenu";
export default function MainLayout() {
  return (
    <div className="flex min-h-screen text-xxs">
      <div className="w-24">
        <div className="h-16 bg-veko-blue-new flex justify-center items-center border-r border-blue-900">
          <img src={logo} alt="" width={70} />
        </div>
        <div className="border-r min-h-full">
          <SideMenu />
        </div>
      </div>
      <div className="flex-1">
        <div className="flex text-md items-center justify-between h-16 bg-veko-blue-new px-4">
          <div className="flex items-center">
            <div className=" text-white">
              <span className="font-bold">VEKO</span>
              <span className="font-thin"></span>
            </div>
            <div className="border-l pl-2 ml-2 text-white font-thin">
              Sales Portal
            </div>
          </div>
          <div className="text-white">DC</div>
        </div>

        <div className=" h-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
